import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as constant from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  api_URL = constant.environment.cmaapiUrl;
  loginCredentialsSubject = new Subject();
  rememberData = this.loginCredentialsSubject.asObservable();
  constructor(private http: HttpClient) { }

  login(registration_id, password){
    localStorage.clear();
   return this.http.post(this.api_URL + 'studentLogin',{ registration_id, password });
  }

  forgotPassword(params:any){
    return this.http.post(this.api_URL + 'student/forgotPassword',params);
  }


}

